import * as yup from 'yup';
import { Step } from '../../CharitableGiving.meta';

export const STEP_ID: Step = 'donor';

export interface FormValues {
  donor: number | null;
}

export const validation = yup.object().shape({
  donor: yup
    .number()
    .nullable()
    .required('Please, select a donor'),
});
